import React from "react";

const ArrowDownIcon = ({ className, size = 12, style, ...props }) => (
  <svg
    className={className}
    width={size}
    height={size}
    style={{
      width: size,
      height: size,
      minWidth: size,
      minHeight: size,
      ...style,
    }}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.99989 8.37538C5.90389 8.37538 5.80787 8.33889 5.73487 8.26539L2.23488 4.76539C2.08838 4.61889 2.08838 4.38138 2.23488 4.23488C2.38138 4.08838 2.61889 4.08838 2.76539 4.23488L6.00038 7.46986L9.23536 4.23488C9.38186 4.08838 9.61938 4.08838 9.76588 4.23488C9.91238 4.38138 9.91238 4.61889 9.76588 4.76539L6.26588 8.26539C6.19188 8.33889 6.09589 8.37538 5.99989 8.37538Z"
      fill="white"
    />
  </svg>
);

export default ArrowDownIcon;
